import { Injectable } from '@angular/core';
import {
  ColDef, ICellRendererParams, IFilterOptionDef, ITextFilterParams,
  SetFilterValuesFuncParams,
  ValueFormatterParams,
  ValueGetterParams,
  ValueSetterParams
} from 'ag-grid-community';
import {ObsoleteComponent} from '../grid/dialogs/obsolete/obsolete.component';
import {CellEditorRelatedProductsComponent} from '../grid/cell-editors/cell-editor-related-products/cell-editor-related-products.component';
import {CellEditorBrandComponent} from '../grid/cell-editors/cell-editor-brand/cell-editor-brand.component';
import {CellEditorTypeComponent} from '../grid/cell-editors/cell-editor-type/cell-editor-type.component';
import {CellEditorTagsComponent} from '../grid/cell-editors/cell-editor-tags/cell-editor-tags.component';
import { StorageService } from './storage.service';
import validator from 'validator';
import {ToastService} from './toast.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {ConfirmationCellComponent} from '../grid/components/confirmation-cell/confirmation-cell.component';
import {SkuComponent} from '../grid/cell/sku/sku.component';
import {CellEditorAsmTagsComponent} from '../grid/cell/cell-editor-asm-tags/cell-editor-asm-tags.component';
import {TagsFilterComponent} from '../grid/filters/tags-filter/tags-filter.component';
import {
  CellEditorShippingTagsComponent
} from '../grid/cell-editors/cell-editor-shipping-tags/cell-editor-shipping-tags.component';
import {CellEditorDatasheetComponent} from '../grid/cell-editors/cell-editor-datasheet/cell-editor-datasheet.component';
import {StatusCellComponent} from '../grid/cell/status-cell/status-cell.component';
import {TagsCustomFilterComponent} from '../grid/filter/tags-custom-filter/tags-custom-filter.component';
import { CellEditorVendorTagsComponent } from '../grid/cell-editors/cell-editor-vendor-tags/cell-editor-vendor-tags.component';
import {
  CellEditorRelatedPartsComponent
} from '../grid/cell-editors/cell-editor-related-parts/cell-editor-related-parts.component';
import {LocalStorageService} from './local-storage.service';
import {OldStructureCellComponent} from "../grid/cell/old-structure-cell/old-structure-cell.component";
import {AiStructureCellComponent} from "../grid/cell/ai-structure-cell/ai-structure-cell.component";
import {environment} from "../../environments/environment";
import {renderUpdateMethod} from "../helpers/update-method.util";
import {AiTitleCellRendererComponent} from "../grid/cell/ai-title-cell-renderer/ai-title-cell-renderer.component";

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public numberValidator(params: any): boolean {
    const fieldName: any = params?.colDef?.field;
    const newValue = params.newValue.toString();
    if (newValue.split('.')[0].length <= 9 && (validator.isInt(params.newValue) || validator.isFloat(params.newValue))) {
      params.data[fieldName] = params.newValue;
      return true;
    } else {
      this.toastService.errorValidationCell('Invalid Set Value', params.colDef.headerName, {timeOut: 7000}, params);
      return false;
    }
  }

  public exportMessageId: any;

  public containsFilterParams = {
    suppressAndOrCondition: true,
    debounceMs: 400,
    defaultOption: 'equals',
    filterOptions: [
      'contains',
      'notContains',
      'equals',
      'notEqual',
      'startsWith',
      {
        displayKey: 'notStartsWith',
        displayName: 'Does not start with',
        predicate: (_, cellValue) => {
          return true;
        },
        numberOfInputs: 1,
      },
      'endsWith',
      {
        displayKey: 'notEndsWith',
        displayName: 'Does not end with',
        predicate: (_, cellValue) => {
          return true;
        },
        numberOfInputs: 1,
      },
      'blank',
      'notBlank',
    ] as IFilterOptionDef[]
  };

  public currencyValidator(params: any): boolean {
    const fieldName: any = params?.colDef?.field;
    if (params.newValue) {
      const newValueInit = String(params.newValue).replace('$', '').replace(',', '').replace(/ /g, '');
      const newValue = Number(newValueInit).toFixed(2);
      if (newValue.split('.')[0].length <= 9 && validator.isCurrency(newValue, {
        symbol: '',
      })) {
        params.data[fieldName] = Number(newValue).toFixed(2);
        return true;
      } else {
        this.toastService.errorValidationCell('Invalid Set Value', params.colDef.headerName, {timeOut: 7000}, params);
        return false;
      }
    } else {
      return false;
    }
  }

  private coerceBooleanValue(raw: any): boolean {
    if (raw === undefined || raw === null) {
      return false;
    }

    if (typeof raw === 'object') {
      if (Object.prototype.hasOwnProperty.call(raw, 'production')) {
        return this.coerceBooleanValue(raw.production);
      }
      if (Object.prototype.hasOwnProperty.call(raw, 'shopify')) {
        return this.coerceBooleanValue(raw.shopify);
      }
      if (Object.prototype.hasOwnProperty.call(raw, 'stage')) {
        return this.coerceBooleanValue(raw.stage);
      }
    }

    if (typeof raw === 'string') {
      const normalized = raw.trim().toLowerCase();
      return normalized === 'true' || normalized === '1' || normalized === 'yes';
    }

    if (typeof raw === 'number') {
      return raw === 1;
    }

    return !!raw;
  }

  private coerceBooleanString(raw: any): string {
    return this.coerceBooleanValue(raw) ? 'true' : 'false';
  }

  private handleFix(handle: string) {
    return handle
      .toLowerCase()
      .replace(/[^a-zA-Z0-9_]/g, '-')
      .replace(/------/g, '-')
      .replace(/-----/g, '-')
      .replace(/----/g, '-')
      .replace(/---/g, '-')
      .replace(/--/g, '-')
      .replace(/-*$/, '')
      .replace(/^-+/, '');
  }

  public handleValidator(params: any) {
    const fieldName: any = params?.colDef?.field;
    const regexExp = /^[A-Za-z0-9_]+(?:-[A-Za-z0-9_]+)*$/;

    params.data[fieldName] = this.handleFix(params.newValue);
    return true;
    // if (regexExp.test(params.newValue) && validator.isSlug(params.newValue.replace(/_/g, ''))) {
    //   params.data[fieldName] = params.newValue;
    //   return true;
    // } else {
    //   this.toastService.errorValidationCell('Invalid Set Value', params.colDef.headerName, {timeOut: 7000}, params);
    //   return false;
    // }
    // if (validator.isSlug(params.newValue, )) {
    //   params.data[fieldName] = params.newValue;
    //   return true;
    // } else {
    //   this.toastService.error('Invalid Set Value', params.colDef.headerName, {timeOut: 7000});
    //   return false;
    // }
  }

  public postalValidator(params: any): boolean {
    const fieldName: any = params?.colDef?.field;
    if (validator.isPostalCode(params.newValue, 'US')) {
      params.data[fieldName] = params.newValue;
      return true;
    } else {
      this.toastService.errorValidationCell('Invalid Set Value', params.colDef.headerName, {timeOut: 7000}, params);
      return false;
    }
  }

  public stringValidator(params: any): boolean {
    console.log('stringValidator', params);
    const fieldName: any = params?.colDef?.field;
    if (params.newValue !== undefined) {
      if (validator.isLength(params.newValue, {
        max: 30000000
      }) || params.newValue.length === 0) {
        params.data[fieldName] = params.newValue;
        return true;
      } else {
        this.toastService.errorValidationCell('Invalid Set Value', params.colDef.headerName, {timeOut: 7000}, params);
        return false;
      }
    } else {
      return false;
    }
  }

  public urlValidator(params: any): boolean {
    const fieldName: any = params?.colDef?.field;
    if (validator.isURL(params.newValue, {
      require_protocol: true,
      allow_underscores: true
    })) {
      params.data[fieldName] = params.newValue;
      return true;
    } else {
      this.toastService.errorValidationCell('Invalid Set Value', params.colDef.headerName, {timeOut: 7000}, params);
      return false;
    }
  }

  public columnDefs: ColDef[] = [
    // agDateColumnFilter
    // { headerName: 'index', valueGetter: 'node.rowIndex', minWidth: 100 },
    {
      field: '_id',
      headerName: 'id',
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'shopify_id',
      headerName: 'bhs_shopify_id',
      minWidth: 295,
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      // suppressFiltersToolPanel: true,
      // suppressColumnsToolPanel: true,
    },
    {
      field: 'mws_shopify_id',
      headerName: 'mws_shopify_id',
      minWidth: 295,
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      // suppressFiltersToolPanel: true,
      // suppressColumnsToolPanel: true,
    },
    {
      field: 'title_ai',
      headerName: 'title_ai',
      minWidth: 295,
      editable: false,
      // hide: environment.staging === false ? true : false,
      hide: true,
      filter: 'agTextColumnFilter',
      cellRenderer: AiTitleCellRendererComponent,
      filterParams: {
        suppressAndOrCondition: true,
        debounceMs: 400,
        filterOptions: [
          'contains',
          'blank',
          'notBlank',
        ]
      },
    },
    {
      field: 'update_method',
      headerName: 'Update method',
      minWidth: 295,
      editable: false,
      hide: true,
      suppressColumnsToolPanel: true,
      cellRenderer: (params: any) => {
        // Keep the Import link only while its uploaded file is within
        // retention; otherwise render plain text so no one clicks a dead link.
        const html = renderUpdateMethod(params.value);
        if (html.includes('<a')) {
          const el = document.createElement('div');
          el.innerHTML = html;
          return el;
        }
        return html;
      },
    },
    {
      field: 'collections',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'Collections',
      minWidth: 550,
      flex: 1,
      // hide: environment.staging === false ? true : false,
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        debounceMs: 400,
        filterOptions: [
          'contains',
          'blank',
          'notBlank',
        ]
      },
      cellRenderer: AiStructureCellComponent,
      // cellRenderer: (cell: any) => {
      //   if (cell.value) {
      //     console.log(cell.value);
      //     return '<div class="collection-tag__container">' + cell.value.map((collection: any) => `<span class="collection-tag">${collection.title.split(' -> ').join(' → ')}</span>`).join('') + '</div>';
      //   } else {
      //     return '';
      //   }
      // }
    },
    // {
    //   field: 'aicurrentstructures',
    //   headerName: 'bhs_old_structure',
    //   minWidth: 220,
    //   filter: false,
    //   suppressFiltersToolPanel: true,
    //   // filter: 'agTextColumnFilter',
    //   // suppressMenu: true,
    //   editable: false,
    //   cellRenderer: OldStructureCellComponent,
    // },
    // {
    //   field: 'ailearngptresults',
    //   headerName: 'Collections',
    //   minWidth: 570,
    //   filter: false,
    //   suppressFiltersToolPanel: true,
    //   editable: false,
    //   cellRenderer: AiStructureCellComponent,
    // },
    {
      field: 'imported',
      hide: true,
      editable: false,
      filter: 'agSetColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      filterParams: {
        defaultToNothingSelected: true,
        values: (params: any) => {
          params.success(this.storageService.users?.map(u => u._id));
        },
        // suppressSorting: true,
        valueFormatter: (cell: any) => {
          console.log('cell', cell);
          return cell.value?.user?._id;
        }
      },
      cellRenderer: (data: any) => {
        return JSON.stringify(data.value);
      }
    },
    // {
    //   field: 'mws_shopify_id',
    //   headerName: 'mws_shopify_id',
    //   minWidth: 400,
    //   filter: 'agTextColumnFilter',
    //   filterParams: this.containsFilterParams,
    // },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 170,
      maxWidth: 170,
      editable: false,
      pinned: 'left',
      cellRenderer: StatusCellComponent,
      // hide: true,
      filter: 'agTextColumnFilter',
      menuTabs: ['filterMenuTab'],
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: [
          {
            displayKey: 'all',
            displayName: 'All Products',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'allModifiedProducts',
            displayName: 'All Modified Products',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'waitingForApproval',
            displayName: 'Waiting Approval',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'confirmed',
            displayName: 'Confirmed',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'conflicts',
            displayName: 'Conflicts',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'new',
            displayName: 'New Products',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'syncError',
            displayName: 'Sync Error',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'contains',
            displayName: 'Contains',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
        ]
      },
      // suppressMenu: false,
      // suppressFiltersToolPanel: true,
      // suppressColumnsToolPanel: true,
      // menuTabs: ['columnsMenuTab'],
      enablePivot: false,
      // enableValue: false,
      enableRowGroup: false,
      // sortable: false
    },
    {
      field: 'confirm',
      headerName: 'Сonfirmation',
      cellRenderer: ConfirmationCellComponent,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      hide: true,
      pinned: true,
      maxWidth: 180,
      suppressNavigable: true,
      sortable: false,
      cellClass: 'no-border',
    },
    {
      field: 'pushed_user',
      headerName: 'User',
      minWidth: 170,
      hide: true,
      // filter: 'agTextColumnFilter',
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.users.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.users.find(b => b._id === cell.value)) {
            return this.storageService.users.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      },
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      cellRenderer: (cell: any) => {
        const user = this.storageService.users.find((u: any) => u._id === cell.value._id);
        return user?.name;
      }
    },
    {
      field: 'changed_by',
      headerName: 'Changed By',
      minWidth: 130,
      sortable: false,
      hide: true,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.users.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.users.find(b => b._id === cell.value)) {
            return this.storageService.users.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      },
      cellRenderer: (cell: any) => {
        return cell.data.users_activity?.map((u: any) => u.name).join(', ');
      }
    },
    {
      field: 'updated_at',
      headerName: 'Modification date',
      filter: 'agDateColumnFilter',
      hide: true,
      sort: null,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      filterParams: {
        minValidYear: 2022,
        filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
        suppressAndOrCondition: true,
      },
      minWidth: 210,
      valueFormatter: (data: any) => {
        // const date = new Date(data.value);
        // const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        return data.value ? (new Date(data.value)).toLocaleDateString() + ' ' + (new Date(data.value)).toLocaleTimeString() : '';
        // return data.value ? formattedDate + ' ' + formattedDate : '';
      }
    },
    {
      field: 'created_at',
      headerName: 'Date Added',
      filter: 'agDateColumnFilter',
      hide: true,
      sort: null,
      editable: false,
      filterParams: {
        minValidYear: 2000,
        filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
        suppressAndOrCondition: true,
      },
      minWidth: 160,
      valueFormatter: (data: any) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      field: 'pushed_at',
      headerName: 'Modification date',
      hide: true,
      minWidth: 210,
      filter: 'agDateColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      filterParams: {
        minValidYear: 2022,
        filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
        suppressAndOrCondition: true,
      },
      sort: null,
      // valueFormatter: (data: any) => {
      //   const date = new Date(data.value);
      //   const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
      //   return data.value ? formattedDate + ' ' + date.toLocaleTimeString() : '';
      // },
      cellRenderer: (data: any) => {
        // const date = new Date(data.value);
        // const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        // return data.value ? formattedDate + ' ' + date.toLocaleTimeString() : '';
        return data.value ? (new Date(data.value)).toLocaleDateString() + ' ' + (new Date(data.value)).toLocaleTimeString() : '';
      }
    },
    {
      field: 'product_id',
      headerName: 'Product ID',
      filter: 'agTextColumnFilter',
      minWidth: 250,
      editable: false,
      floatingFilter: true,
      filterParams: this.containsFilterParams,
      // suppressMenu: true,
      // filterParams: {suppressAndOrCondition: true,},
    },
    {
      field: 'sku',
      headerName: 'SKU',
      filter: 'agTextColumnFilter',
      pinned: true,
      checkboxSelection: true,
      minWidth: 250,
      sort: null,
      floatingFilter: true,
      filterParams: this.containsFilterParams,
      cellRenderer: SkuComponent
    },
    {
      field: 'related_products',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'Related Accessories',
      cellEditor: CellEditorRelatedProductsComponent,
      cellEditorPopup: true,
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellRenderer: (cell: any) => {
        if (cell.value && cell.value.length) {
          return cell.value.map((product: any) => product.sku).join(', ');
        } else {
          return null;
        }
      },
    },
    {
      field: 'related_parts',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'Related Parts',
      cellEditor: CellEditorRelatedPartsComponent,
      cellEditorPopup: true,
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellRenderer: (cell: any) => {
        if (cell.value && cell.value.length) {
          return cell.value.map((product: any) => product.sku).join(', ');
        } else {
          return null;
        }
      },
    },
    {
      field: 'related_collections',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'Related Collections',
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      cellRenderer: (cell: any) => {
        if (cell.value && cell.value.length) {
          return cell.value;
        } else {
          return null;
        }
      },
    },
    {
      field: 'shopify_published',
      headerName: 'BHS Published',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: [true, false],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return cell.value === true || cell.value === 'true' ? 'true' : 'false';
        }
      },
      cellRenderer: (cell: any) => {
        return cell.value === true || cell.value === 'true';
      }
    },
    {
      field: 'mws_shopify_published',
      headerName: 'MWS Published',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: [true, false],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return cell.value === true || cell.value === 'true' ? 'true' : 'false';
        }
      },
      cellRenderer: (cell: any) => {
        return +cell.data.mws_shopify_published === 1;
      }
    },
    {
      field: 'replacement.obsolete',
      headerName: 'Obsolete',
      hide: true,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true
    },
    {
      field: 'replacement',
      headerName: 'Replacement SKU',
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        // filterOptions: ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith', 'blank', 'empty']
        filterOptions: [
          {
            displayKey: 'contains',
            displayName: 'Contains',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
          {
            displayKey: 'notContains',
            displayName: 'Not contains',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
          {
            displayKey: 'equals',
            displayName: 'Equals',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
          {
            displayKey: 'notEqual',
            displayName: 'Not equal',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
          {
            displayKey: 'startsWith',
            displayName: 'Starts with',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
          {
            displayKey: 'endsWith',
            displayName: 'Ends with',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: false,
          },
          {
            displayKey: 'obsolete',
            displayName: 'Has replacement SKU',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'noObsolete',
            displayName: 'false',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
          {
            displayKey: 'noReplacement',
            displayName: 'true',
            test: function (filterValue: any, cellValue: any) {
              return filterValue;
            },
            hideFilterInput: true,
          },
        ]
      },
      cellEditor: ObsoleteComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        if (cell.data.replacement?.obsolete && !cell.data.replacement?.sku) {
          // return 'Obsolete / NO replacement';
          return 'true';
        } else if (cell.data.replacement?.sku) {
          return cell.data.replacement?.sku;
        } else {
          return 'false';
        }
      },
      // cellClass: (cell: any) => {
      //   const cellChanged = (cell.data?.changes?.replacement);
      //
      //   if (cellChanged) {
      //     return 'ag-cell-changed';
      //   } else {
      //     return '';
      //   }
      // }
    },
    {
      field: 'handle',
      headerName: 'Handle',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      minWidth: 250,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 2000,
        rows: 10,
        cols: 50
      },
      cellEditorPopup: true,
      valueSetter: (params: ValueSetterParams) => { return this.handleValidator(params) }
    },
    {
      field: 'brand',
      headerName: 'Brand',
      cellEditor: CellEditorBrandComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.name;
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.brands.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.brands.find(b => b._id === cell.value)) {
            return this.storageService.brands.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 130,
      cellEditor: CellEditorTypeComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        // console.log('🔴', cell);
        // return this.storageService.types.find(b => b._id === cell.value._id) ? this.storageService.types.find(b => b._id === cell.value._id).name : null;
        return cell.value?.name;
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.types.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.types.find(b => b._id === cell.value)) {
            return this.storageService.types.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'description',
      headerName: 'Description',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: { ...this.containsFilterParams, defaultOption: 'contains' },

      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      minWidth: 340,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      cellEditorPopup: true,
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'ai_description',
      headerName: 'AI Description',
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      editable: false,
      hide: true,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      minWidth: 340,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
    },
    {
      field: 'pricing_id',
      headerName: 'Pricing ID',
      filter: 'agTextColumnFilter',
      minWidth: 250,
      floatingFilter: true,
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
    },
    {
      field: 'list_price',
      headerName: 'List Price',
      minWidth: 130,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        // filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
      },
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return '$' + 0.00.toFixed(2).toString();
        }
      },
      valueSetter: (params: ValueSetterParams) => { return this.currencyValidator(params) }
    },
    {
      field: 'cost_price',
      headerName: 'Cost Price',
      minWidth: 130,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        // filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
      },
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return '$' + 0.00.toFixed(2).toString();
        }
      },
      valueSetter: (params: ValueSetterParams) => { return this.currencyValidator(params) }
    },
    {
      field: 'sell_price',
      headerName: 'BHS Sell Price',
      minWidth: 145,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
      },
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return '$' + 0.00.toFixed(2).toString();
        }
      },
      valueSetter: (params: ValueSetterParams) => { return this.currencyValidator(params) }
    },
    {
      field: 'mws_sell_price',
      headerName: 'MWS Sell Price',
      minWidth: 150,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
      },
      cellRenderer: (cell: any) => {
        if (cell.value !== '' && /^[-+]?[0-9]*\.?[0-9]+$/g.test(cell.value) && !isNaN(parseFloat(cell.value)) && typeof parseFloat(cell.value) === 'number') {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return cell.value
        }
        // const calc_mws_price = (product: any) => {
        //   let s1 = this.localStorageService.getItem('mwsPriceFormula');
        //   for (const row of ['list_price','cost_price','sell_price', 'mws_sell_price']) {
        //     const val = product[row];
        //     s1 = s1.replaceAll(`[[field-data-${row}]]`, val === undefined ? '' : val);
        //   }
        //   return Function('return ' + s1)();
        // }
        // if (cell.value === 0 && cell.data.cost_price !== 0) {
        //   return `<span style="color: #02189d;font-weight: bold;">$${parseFloat(String(calc_mws_price(cell.data))).toFixed(2).toString()}</span>`;
        // } else {
        //   if (cell.value) {
        //     return '$' + parseFloat(cell.value).toFixed(2).toString();
        //   } else {
        //     return null;
        //   }
        // }
      },
      // valueSetter: (params: ValueSetterParams) => { return this.currencyValidator(params) }
    },
    {
      field: 'out_of_stock',
      headerName: 'Out of Stock',
      cellEditor: 'agRichSelectCellEditor',
      minWidth: 136,
      maxWidth: 140,
      cellEditorParams: {
        values: [true, false],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return cell.value && cell.value === 'true' ? 'true' : 'false';
        }
      },
      cellRenderer: (cell: any) => {
        return +cell.data.out_of_stock === 1;
      }
    },
    {
      field: 'bh_gaq',
      headerName: 'BH-GAQ',
      maxWidth: 140,
      cellStyle: { 'text-align': 'center' },
      cellEditor: 'agRichSelectCellEditor',
      minWidth: 136,
      valueGetter: (params: any) => {
        return this.coerceBooleanValue(params.data?.bh_gaq);
      },
      cellEditorParams: {
        values: [true, false],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return this.coerceBooleanValue(cell.value) ? 'true' : 'false';
        }
      },
      cellRenderer: (cell: any) => {
        return this.coerceBooleanValue(cell.value);
      }
    },
    {
      field: 'mw_gaq',
      headerName: 'MW-GAQ',
      maxWidth: 140,
      cellStyle: { 'text-align': 'center' },
      cellEditor: 'agRichSelectCellEditor',
      valueGetter: (params: any) => {
        return this.coerceBooleanValue(params.data?.mw_gaq);
      },
      cellEditorParams: {
        values: [true, false],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return this.coerceBooleanValue(cell.value) ? 'true' : 'false';
        }
      },
      cellRenderer: (cell: any) => {
        return this.coerceBooleanValue(cell.value);
      }
    },
    {
      field: 'pack_qty',
      headerName: 'Pack Qty',
      maxWidth: 140,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
      },
      valueSetter: (params: ValueSetterParams) => { return this.numberValidator(params) }
    },
    {
      field: 'image',
      headerName: 'Image',
      minWidth: 270,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      //   // filterOptions: ['contains']
      // },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      cellEditorPopup: true,
      // valueSetter: (params: ValueSetterParams) => { return this.urlValidator(params) }
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'datasheet_new',
      headerName: 'Datasheet',
      cellEditor: CellEditorDatasheetComponent,
      cellEditorPopup: true,
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellRenderer: (cell: any) => {
        if (cell?.value?.length) {
          return cell.value.map((x: any) => x.url).join(', ');
          // return cell.value.split(',').join(', ');
        } else {
          return null;
        }
      },
    },
    {
      field: 'installation_instructions',
      headerName: 'Installation Instructions',
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      cellEditorPopup: true,
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'url_manufacturer',
      headerName: 'URL Manufacturer',
      minWidth: 300,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      //   // filterOptions: ['contains']
      // },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      cellEditorPopup: true,
      // valueSetter: (params: ValueSetterParams) => { return this.urlValidator(params) }
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_seo',
      headerName: 'Body',
      // pinned: 'left',
      minWidth: 500,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'tags',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'Tags',
      cellEditor: CellEditorTagsComponent,
      minWidth: 400,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        let tags: any = [];
        cell.value?.forEach((tag: any) => {
          const name = this.storageService.tagMap.get(tag._id);
          if (name) {
            tags.push(name);
          }
        });
        return tags.join(', ');
      },
      filter: TagsFilterComponent,
      filterParams: {
        tags: () => this.storageService.tags,
      }
    },
    {
      field: 'shipping_tag',
      headerName: 'Shipping Tag',
      // pinned: 'left',
      cellEditor: CellEditorShippingTagsComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        if (cell.value?.name) {
          return cell.value?.name === 'Not Selected' ? '' : cell.value?.name;
        } else {
          const val = this.storageService.shippingTags.find(b => b._id === cell.value)?.name;
          return val === 'Not Selected' ? '' : val;
        }
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.shippingTags.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.shippingTags.find(b => b._id === cell.value)) {
            return this.storageService.shippingTags.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'vendor_tags',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'Vendor Tags',
      cellEditor: CellEditorVendorTagsComponent,
      minWidth: 400,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        let tags: any = [];
        cell.value?.forEach((tag: any) => {
          const finder = this.storageService.vendorTags.find(t => t._id === tag._id);
          if (finder) {
            tags.push(finder.name);
          }
        });
        return tags.join(', ');
      },
      filterParams: {
        // cellRenderer: TagsCustomFilterComponent,
        cellRendererParams: { isFilterRenderer: true },
        // suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.vendorTags.map(b => b.name));
        },
        // valueFormatter: (cell: any) => {
        //   if (this.storageService.tags.find(b => b._id === cell.value)) {
        //     return this.storageService.tags.find(b => b._id === cell.value).name;
        //   } else {
        //     return null;
        //   }
        // }
      }
      // filter: 'agSetColumnFilter',
      // filterParams: {
      //   cellRenderer: TagsCustomFilterComponent,
      //   cellRendererParams: { isFilterRenderer: true },
      //   values: (params: SetFilterValuesFuncParams) => {
      //     params.success(this.storageService.vendorTags.map(b => b.name));
      //   },
      // }
    },
    {
      field: 'asm_tags',
      // Array-valued column: a server-side sort on it scans/sorts all
      // 1.9M docs (10s+) and the ordering is meaningless anyway.
      sortable: false,
      headerName: 'ASM Tags',
      minWidth: 400,
      cellEditor: CellEditorAsmTagsComponent,
      // pinned: 'left',
      cellEditorPopup: true,
      filter: 'agSetColumnFilter',
      cellRenderer: (cell: any) => {
        return cell.value?.split(',')?.join(', ');
      },
      filterParams: {
        // values: ['Blank', 'Dimensions', 'Exclude countries', 'Exclude states', 'Flat ship rates', 'Free ship method', 'Free shipping', 'Global free ship exclusion', 'Invalid ship methods', 'Markup', 'Multi box weights', 'Number of boxes', 'Origin ZIP', 'Ship alone'],
        values: ['Dimensions', 'Exclude countries', 'Exclude states', 'Flat ship rates', 'Free ship method', 'Free shipping', 'Global free ship exclusion', 'Invalid ship methods', 'Markup', 'Multi box weights', 'Number of boxes', 'Origin ZIP', 'Ship alone'],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return cell.value;
        }
      }
    },
    {
      field: 'google_category',
      headerName: 'Google Category',
      minWidth: 170,
      filter: 'agNumberColumnFilter',
      valueSetter: (params: ValueSetterParams) => { return this.numberValidator(params) }
    },
    {
      field: 'upc_gtin',
      headerName: 'UPC/GTIN',
      minWidth: 130,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'weight_lbs',
      headerName: 'Weight LBS',
      minWidth: 170,
      filter: 'agNumberColumnFilter',
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return parseFloat(cell.value).toFixed(2).toString();
        } else {
          return null;
        }
      },
      valueSetter: (params: ValueSetterParams) => { return this.numberValidator(params) }
    },
    // Weight-estimator metadata — read-only provenance columns. weight_source
    // shows whose number the live weight is; the est_* columns show what the
    // algorithm computed (for control products too, so est-vs-actual is
    // always visible).
    {
      field: 'weight_source',
      headerName: 'Weight Source',
      minWidth: 130,
      editable: false,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      cellRenderer: (cell: any) => {
        if (!cell.value || cell.value === 'vendor') return cell.value ? 'vendor' : null;
        const color = cell.value === 'recovered' ? 'var(--bhs-toast-success, #2e7d32)' : 'var(--bhs-status-warn, #b45309)';
        return `<span style="color:${color};font-weight:600;">${cell.value}</span>`;
      }
    },
    {
      field: 'weight_est_lbs',
      headerName: 'Est. Weight',
      minWidth: 120,
      editable: false,
      filter: 'agNumberColumnFilter',
      cellRenderer: (cell: any) => {
        return cell.value != null ? parseFloat(cell.value).toFixed(2) : null;
      }
    },
    {
      field: 'weight_est_tier',
      headerName: 'Est. Basis',
      minWidth: 150,
      editable: false,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      cellRenderer: (cell: any) => {
        if (!cell.value) return null;
        const labels: any = { weight_tag: 'Weight tag', duplicate: 'Duplicate SKU', prefix: 'SKU family', text: 'Description', type: 'Brand+Type' };
        const conf = cell.data?.weight_est_confidence != null ? ` · ${Math.round(cell.data.weight_est_confidence * 100)}%` : '';
        return (labels[cell.value] || cell.value) + conf;
      }
    },
    {
      field: 'weight_est_error_pct',
      headerName: 'Est. Err %',
      minWidth: 110,
      editable: false,
      filter: 'agNumberColumnFilter',
      cellRenderer: (cell: any) => {
        if (cell.value == null) return null;
        const v = parseFloat(cell.value);
        const style = v < 0 ? 'color:var(--bhs-status-critical, #b71c1c);font-weight:600;' : '';
        return `<span style="${style}">${v > 0 ? '+' : ''}${v.toFixed(1)}%</span>`;
      }
    },
    {
      field: 'title_prefix_1',
      headerName: 'Title Prefix 1',
      // pinned: 'left',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'title_prefix_2',
      headerName: 'Title Prefix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'title_prefix_3',
      headerName: 'Title Prefix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'title_suffix_1',
      headerName: 'Title Suffix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'title_suffix_2',
      headerName: 'Title Suffix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'title_suffix_3',
      headerName: 'Title Suffix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_prefix_1',
      headerName: 'Body Prefix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_prefix_2',
      headerName: 'Body Prefix 2',
      minWidth: 170,
      cellEditorParams: {
        maxLength: 200000,
      },
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_prefix_3',
      headerName: 'Body Prefix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_suffix_1',
      headerName: 'Body Suffix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_suffix_2',
      headerName: 'Body Suffix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditorParams: {
        maxLength: 200000,
      },
      cellEditor: 'agLargeTextCellEditor',
      // cellRenderer: (cell: any) => {
      //   return this.sanitizer.bypassSecurityTrustHtml(cell.value);
      // },
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'body_suffix_3',
      headerName: 'Body Suffix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   suppressAndOrCondition: true,
      // },
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellEditorParams: {
        maxLength: 200000,
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
      valueSetter: (params: ValueSetterParams) => { return this.stringValidator(params) }
    },
    {
      field: 'notes',
      headerName: 'Notes',
      cellEditor: 'agLargeTextCellEditor',
      filter: 'agTextColumnFilter',
      filterParams: this.containsFilterParams,
      cellEditorParams: {
        maxLength: 200000,
      },
      // filterParams: {
      //   suppressAndOrCondition: true,
      // }
    }
  ];

  public defaultColDef: ColDef = {
    resizable: true,
    flex: 1,
    minWidth: 120,
    sortable: true,
    filter: "agTextColumnFilter",
    filterParams: {
      buttons: ['reset'],
    },
    // enableRowGroup: true,
    cellClass: (params: any) => {
      const cellChanged = (params.data?.changes?.[params.colDef.field]);
      const cellPrice = (params.colDef.field === 'list_price' || params.colDef.field === 'cost_price' || params.colDef.field === 'sell_price' || params.colDef.field === 'mws_sell_price');

      if (cellPrice && cellChanged) {
        return ['number-cell', 'ag-cell-changed'];
      } else if (cellChanged) {
        return 'ag-cell-changed';
      } else if (params.colDef.field === 'sku') {
        return 'sku-col';
      } else if (cellPrice) {
        return 'number-cell';
      }

      return '';
    }
  };

  constructor(
    private storageService: StorageService,
    private toastService: ToastService,
    private sanitizer: DomSanitizer,
    public localStorageService: LocalStorageService
  ) { }
}
